import styled from '@emotion/styled';
import { Dialog, DialogProps } from '@mui/material';
import { CSSProperties } from 'react';

interface DialogStyledProps extends DialogProps {
  customWidth?: CSSProperties['width'];
  customMaxWidth?: CSSProperties['maxWidth'];
  customMinWidth?: CSSProperties['minWidth'];
}

const IGNORED_PROPS = ['customWidth', 'customMaxWidth', 'customMinWidth'];

export const DialogStyled = styled(Dialog, {
  shouldForwardProp: (prop) => !IGNORED_PROPS.includes(prop),
})<DialogStyledProps>(
  ({
    theme,
    customWidth = '90%',
    customMaxWidth = 600,
    customMinWidth = 294,
  }) => ({
    '& .MuiDialog-paper': {
      // padding: 32,
      borderRadius: 16,
      backgroundColor: '#F1F1F1',
      position: 'relative',
      width: customWidth,
      maxWidth: customMaxWidth,
      minWidth: customMinWidth,
    },
  }),
);

DialogStyled.defaultProps = {
  disableScrollLock: true,
};
